import { createContext, useContext, useState } from "react";

const CheckoutContext = createContext();

export const CheckoutProvider = ({ children }) => {
  const [order, setOrder] = useState(null);
  const [shipping,setShipping] = useState(null);

  return (
    <CheckoutContext.Provider value={{ order, setOrder, shipping, setShipping}}>
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckout = () => {
  return useContext(CheckoutContext);
};